import React, { useMemo, useState } from 'react'
import Link from 'next/link'
import { FiChevronRight } from 'react-icons/fi'
import topics from '../stores/topics'
import TrackOrderForm from '../forms/TrackOrderForm'
import OrderStatusModal from './OrderStatusModal'

interface IHelpCenterProps {}

const footerPages = [
  { name: 'Create account/sign in', href: '/account/login' },
  { name: 'Reset password', href: '/account/recover-password' },
  { name: 'Sizing charts', href: '/sizechart' },
]

const HelpCenter: React.FC<IHelpCenterProps> = () => {
  const topicKeys = useMemo(() => Object.keys(topics), [])
  const [orderBeingViewed, setOrderBeingViewed] = useState<object | undefined>(
    undefined
  )
  return (
    <div className={'help-center'}>
      <h1
        className={
          'mb-8 uppercase text-3xl sm:text-5xl font-black tracking-tighter text-center text-black'
        }
      >
        Help Center
      </h1>
      <div className={'bg-gray-50 py-12 px-6 rounded'}>
        <div className={'max-w-sm mx-auto'}>
          <TrackOrderForm onOrderStatusData={setOrderBeingViewed} />
          {orderBeingViewed && (
            <OrderStatusModal
              order={orderBeingViewed as any}
              onClose={() => {
                setOrderBeingViewed(undefined)
              }}
            />
          )}
        </div>
      </div>
      <div
        className={
          'mx-auto flex-col space-y-4 sm:space-y-0 pt-8 pb-7 flex sm:flex-row sm:space-x-4 items-center justify-center border-b border-gray-200'
        }
      >
        <Link href={'/help/shipping-options'}>
          <a
            className={
              'rounded-full bg-gray-100 px-7 py-5 font-medium text-base text-black hover:bg-gray-200 hover:text-black transition-colors ease-in'
            }
          >
            Shipping Info
          </a>
        </Link>
        <Link href={'/help/i-have-a-problem-with-my-order'}>
          <a
            className={
              'rounded-full bg-gray-100 px-7 py-5 font-medium text-base text-black hover:bg-gray-200 hover:text-black transition-colors ease-in'
            }
          >
            I have a problem with my order
          </a>
        </Link>
      </div>
      <div
        className={
          'pl-4 sm:px-0 max-w-sm sm:max-w-6xl mx-auto flex flex-col space-y-6 sm:space-y-0 sm:space-x-4 sm:flex-row justify-between pt-12 pb-16 sm:text-center'
        }
      >
        {topicKeys.map((topic, i) => (
          <div
            key={i}
            className={
              'flex-1 border-b border-solid pb-6 sm:pb-0 sm:border-0 sm:border-none border-gray-200'
            }
          >
            <h2
              className={
                'font-black uppercase mb-2 text-xl sm:text-lg tracking-tighter text-black'
              }
            >
              {topics[topic as keyof typeof topics].title}
            </h2>
            <ul>
              {/* TODO: Add arrow to topic (using ::after) mobile only */}
              {topics[topic as keyof typeof topics].pages.map((page, i) => (
                <li key={i} className={'-ml-4 sm:ml-0 justify-between flex'}>
                  <Link href={page.href}>
                    <a
                      className={
                        'w-full px-4 py-2 sm:inline-block flex items-center justify-between text-base sm:text-sm hover:bg-gray-100 transition-colors hover:cursor-pointer rounded'
                      }
                    >
                      <div className={'w-full'}>{page.name}</div>
                      <FiChevronRight className={'sm:hidden text-2xl'} />
                    </a>
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <div
        className={
          'container sm:max-w-6xl border-t border-gray-200 pt-6 pb-9 hidden sm:block'
        }
      >
        <div className={'max-w-lg space-x-6 mx-auto text-center'}>
          {footerPages.map((link, i) => (
            <Link href={link.href} key={i}>
              <a
                className={
                  'text-xs text-gray-500 hover:underline cursor-pointer'
                }
              >
                {link.name}
              </a>
            </Link>
          ))}
        </div>
      </div>
    </div>
  )
}

export default HelpCenter
